'use client';

import { useVerParam } from '~/utils/client/url-params';
import UsageFlowPC from './usage-flow-pc';
import UsageFlowSP from './usage-flow-sp';
import { JobDetail } from '~/types/job-detail';

interface ClientUsageFlowProps {
  job: JobDetail;
  isMobile: boolean;
}

export function ClientUsageFlow({ job, isMobile }: ClientUsageFlowProps) {
  const ver = useVerParam();

  if (job.service_type !== '自社提案' || !ver?.includes('issue_4351')) {
    return null;
  }

  return isMobile ? <UsageFlowSP /> : <UsageFlowPC />;
}
